import { inject, Injectable } from '@angular/core';

import { query, orderBy, doc, docSnapshots, docData, collection, collectionSnapshots, collectionData, 
	Firestore, addDoc, updateDoc, deleteDoc, setDoc, limit, startAfter, endBefore, getDocs, 
	QueryDocumentSnapshot, limitToLast, where } from '@angular/fire/firestore';
import { Feedback } from '../classes/feedback';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class FeedbackService {

	firestore: Firestore = inject(Firestore);

	constructor() {
	}

	listFeedbacks() {
		return collectionData(query(collection(this.firestore, 'feedbacks'), orderBy('time', 'desc')), { idField: 'id' })
		.pipe(map(collection => {
			return collection.map(data => {
				let item = new Feedback();
				item.fromJSON(data);
				return item;
			});
		}))
		.pipe(map(items => items.sort((a, b) => {
			return b.time - a.time;
		})));
	}

	async listFeedbacksPaginated(
		pageSize: number, 
		filters: { showArchived?: boolean; gameId?: string; missionId?: string } = {},
		lastDoc?: QueryDocumentSnapshot
	) {
		// Build query constraints array
		const constraints: any[] = [];

		// Add filter constraints
		if (!filters.showArchived) {
			constraints.push(where('status', '!=', 'archived'));
		}
		if (filters.gameId) {
			constraints.push(where('gameId', '==', filters.gameId));
		}
		if (filters.missionId) {
			constraints.push(where('missionId', '==', filters.missionId));
		}

		// Add ordering and pagination
		constraints.push(orderBy('time', 'desc'));
		
		if (lastDoc) {
			constraints.push(startAfter(lastDoc));
		}
		
		constraints.push(limit(pageSize));

		const q = query(collection(this.firestore, 'feedbacks'), ...constraints);
		const snapshot = await getDocs(q);
		const feedbacks: Feedback[] = [];
		
		snapshot.docs.forEach(doc => {
			const feedback = new Feedback();
			feedback.fromJSON({ id: doc.id, ...doc.data() });
			feedbacks.push(feedback);
		});

		return {
			feedbacks,
			lastDoc: snapshot.docs[snapshot.docs.length - 1],
			firstDoc: snapshot.docs[0],
			hasMore: snapshot.docs.length === pageSize
		};
	}

	async listFeedbacksPaginatedPrevious(
		pageSize: number,
		filters: { showArchived?: boolean; gameId?: string; missionId?: string } = {},
		firstDoc: QueryDocumentSnapshot
	) {
		// Build query constraints array
		const constraints: any[] = [];

		// Add filter constraints
		if (!filters.showArchived) {
			constraints.push(where('status', '!=', 'archived'));
		}
		if (filters.gameId) {
			constraints.push(where('gameId', '==', filters.gameId));
		}
		if (filters.missionId) {
			constraints.push(where('missionId', '==', filters.missionId));
		}

		// Add ordering and pagination
		constraints.push(orderBy('time', 'desc'));
		constraints.push(endBefore(firstDoc));
		constraints.push(limitToLast(pageSize));

		const q = query(collection(this.firestore, 'feedbacks'), ...constraints);
		const snapshot = await getDocs(q);
		const feedbacks: Feedback[] = [];
		
		snapshot.docs.forEach(doc => {
			const feedback = new Feedback();
			feedback.fromJSON({ id: doc.id, ...doc.data() });
			feedbacks.push(feedback);
		});

		return {
			feedbacks,
			lastDoc: snapshot.docs[snapshot.docs.length - 1],
			firstDoc: snapshot.docs[0],
			hasMore: true // We know there's more since we're going back
		};
	}

	updateFeedback(feedback, data){
		console.log('Update object:'+'feedbacks'+'/'+feedback.id);
		console.log('DATA:'+JSON.stringify(data));
		return updateDoc(doc(this.firestore, 'feedbacks', feedback.id), data);
	}

	deleteFeedback(feedback) {
		return deleteDoc(doc(this.firestore, 'feedbacks', feedback.id));
	}

	createFeedback(feedbackData) {
		return addDoc(collection(this.firestore, 'feedbacks'), feedbackData);
	}
}

